import React, { useEffect, useCallback } from 'react';
import * as PropTypes from 'prop-types';
import {
  Row, Typography, Button, Skeleton,
} from 'antd';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import '../../configure/Configure.css';
import { connect, useDispatch } from 'react-redux';
import ConfigHeading from '../../configure/components/ConfigHeading';
import { adminRoutes } from '../../../../utility/route-locations';
import './ContactDetails.css';
import { selectAppConfig } from '../../../../state/domain/appConfig/appConfigReducer';
import DisplayAddress from '../../../../components/fields/DisplayAddress';
import { requestBusinessDetails } from '../../../../state/ui/application/appConfigUiActions';

const { Text } = Typography;


/**
 * The display screen for the company configuration data.
 * @param {object} props The react props.
 */
function CompanyDetails({
  history, businessDetails,
}) {
  // Load the initial page data.
  const dispatch = useDispatch();
  const loadPageData = useCallback(() => dispatch(requestBusinessDetails()), [dispatch]);

  useEffect(() => {
    loadPageData();
  }, [loadPageData]);


  return (
    <ConfigHeading
      titleId="contactDetails"
      descriptionId="businessDetailsDesc"
      actions={(
        <Button type="primary" icon="edit" loading={!businessDetails} onClick={() => history.push(`${adminRoutes.admin_company_details}/edit`)}>
          <FormattedMessage id="edit" />
        </Button>
      )}
    >
      <Row>
        <Row className="contact-details-content-row">
          <Row style={{ marginBottom: '12px' }}>
            <Text strong><FormattedMessage id="taxRefNo" /></Text>
          </Row>
          <Row>
            <Text>{businessDetails ? businessDetails.taxReferenceNo || <FormattedMessage id="notProvided" /> : <Skeleton title={false} paragraph={{ width: 200, rows: 1 }} />}</Text>
          </Row>
        </Row>
        <Row className="contact-details-content-row">
          <Row style={{ marginBottom: '12px' }}>
            <Text strong><FormattedMessage id="businessAddress" /></Text>
          </Row>
          <Row>
            {businessDetails
              ? <DisplayAddress address={businessDetails.businessAddress} withLineBreaks />
              : <Skeleton title={false} paragraph={{ width: [200, 200, 200, 200, 100, 100, 100], rows: 7 }} />}
          </Row>
        </Row>
        <Row className="contact-details-content-row">
          <Row style={{ marginBottom: '12px' }}>
            <Text strong><FormattedMessage id="registeredAddress" /></Text>
          </Row>
          <Row>
            {businessDetails
              ? <DisplayAddress address={businessDetails.registeredAddress} withLineBreaks />
              : <Skeleton title={false} paragraph={{ width: [200, 200, 200, 200, 100, 100, 100], rows: 7 }} />}
          </Row>
        </Row>
        <Row className="contact-details-content-row">
          <Row style={{ marginBottom: '12px' }}>
            <Text strong><FormattedMessage id="registeredCompanyNo" /></Text>
          </Row>
          <Row>
            <Text>{businessDetails ? businessDetails.registeredCompanyNo || <FormattedMessage id="notProvided" /> : <Skeleton title={false} paragraph={{ width: 200, rows: 1 }} />}</Text>
          </Row>
        </Row>
      </Row>
    </ConfigHeading>
  );
}

const AddressShape = PropTypes.shape({
  line1: PropTypes.string.isRequired,
  line2: PropTypes.string,
  line3: PropTypes.string,
  line4: PropTypes.string,
  region: PropTypes.string,
  zipPostcode: PropTypes.string,
  country: PropTypes.string.isRequired,
});

CompanyDetails.propTypes = {
  history:
    PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  businessDetails:
    PropTypes.shape({
      businessAddress: AddressShape,
      registeredAddress: AddressShape,
      taxReferenceNo: PropTypes.string,
      registeredCompanyNo: PropTypes.string,
    }),
};

CompanyDetails.defaultProps = {
  businessDetails: null,
};


const mapStateToProps = (state) => ({
  businessDetails: selectAppConfig(state, 'businessDetails') ? selectAppConfig(state, 'businessDetails').applicationConfigValue : null,
});

/**
 * Connect the redux state to our component.
 */
export default connect(mapStateToProps)(withRouter(CompanyDetails));
